import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home'
import About from './pages/Home/About';
import Services from './pages/Home/Services';
import LifeStyleEvation from './pages/Home/LifeStyleEvation';
import BienEtre from './pages/Home/BienEtre';
import Conciergerie from './pages/Home/Conciergerie';
import CultureTour from './pages/Home/CultureTour';
import Formality from './pages/Home/Formality';
import Lounges from './pages/Home/Lounges';
import Adhesion from './pages/Home/Adhesion';
import AzyekosLounges from './pages/Home/AzyekosLounges';
import Galeries from './pages/Home/Galeries';
import Contact from './pages/Home/Contact';
import References from './pages/Home/References';
import Fidelity from './pages/Home/Fidelity'
import RentCars from './pages/Home/RentCars';
import ProfilCar from './pages/Home/ProfilCar';
import ReservationAuto from './pages/Home/ReservationAuto';
import PaiementPages from './pages/Home/PaiementPages';

function App() {
  return (
    <div className="App">
      <Router>
       
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/reference" element={<References/>} />
          <Route path="/LifeStyleEvasion" element={<LifeStyleEvation />} />
          <Route path="/RentCars" element={<RentCars />} />
          <Route path="/Bien-etre" element={<BienEtre />} />
          <Route path="/Conciergerie-privee" element={<Conciergerie />} />
          <Route path="/Culture-Tourisme" element={<CultureTour />} />
          <Route path="/Formalites-aeroportuaire" element={<Formality />} />
          <Route path="/Lounges" element={<Lounges />} />
          <Route path="/Adhesion" element={<Adhesion />} />
          <Route path="/Azyekos-Lounges" element={<AzyekosLounges />} />
          <Route path="/Galerie" element={<Galeries />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Fidelites" element={<Fidelity />} />
          <Route path="/InfoCar/:id" element={<ProfilCar />} />
          <Route path="/reservation-auto/:id/:statut" element={<ReservationAuto />} />
          <Route path="/paiements/:id/:statut" element={<PaiementPages />} />

        </Routes>
      </Router>


    </div>
  );
}

export default App;